import { z } from "zod/mini"

// TODO: Can't we add business logic UID shape validation here? (not uniqueness but format)
export const UIDLegacySchema = z.string()

export type UIDLegacy = z.infer<typeof UIDLegacySchema>
